export default __webpack_public_path__ + "static/media/0041.cc360eb3.jpg";